module.exports = __webpack_public_path__ + "static/media/component-7.7a7bf338.svg";